var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{attrs:{"name":"appsettings"}},[_c('f7-navbar',{attrs:{"title":"App Settings","back-link":"Back"}}),_vm._v(" "),_c('f7-login-screen-title',[_vm._v("Servco App")]),_vm._v(" "),_c('f7-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }